import React from "react";
import Content from "../../Content";
import { Image } from "react-bootstrap";
import * as svg from "../../SvgAssets"
import { Link } from 'react-router-dom'


const listItems = [
  {
    icon: svg.setup,
    label: 'Plug And Play'
  },
  {
    icon: svg.compatibility,
    label: 'Display Compatibility'
  },
  {
    icon: svg.instant,
    label: 'Content Delivery'
  },
  {
    icon: svg.online,
    label: 'Detail Insight'
  },
  {
    icon: svg.monitoring,
    label: 'Monitoring'
  },
  {
    icon: svg.security,
    label: 'Enterprise Grade Security'
  },
  {
    icon: svg.support,
    label: 'A+ Support'
  }
];

const renderedListItem = listItems.map((item, id) => {
  return (
    <div className="col-sm-6 col-md-3" key={id}>
      <div className="thumbnail">
        <Image src={item.icon} alt={item.label}/> <span>{item.label}</span>
      </div>
    </div>
  )
});

export default (props) =>
  <Content className="list-features">
    <div className="list-features row">
      {renderedListItem}
    </div>
    <Link to='/features' className="btn btn-primary">LEARN MORE</Link>
  </Content>




// WEBPACK FOOTER //
// ./src/components/Page/Home/Features.js